export default __webpack_public_path__ + "static/media/IconLocation.2858a3dc.png";